/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ListingSimulationParams = {
    listingId?: string;
    listingType?: ListingSimulationParams.listingType;
    adjustedAmortisationAbo?: number | null;
    pricePoint?: number | null;
    session?: number | null;
    ctr?: number | null;
    constOtaMultiplier?: number | null;
    averageBasket?: number | null;
    aboMultiplier?: number;
    otaMultiplier?: number;
    readonly emptyValues?: boolean;
};
export namespace ListingSimulationParams {
    export enum listingType {
        COUNTRY = 'country',
        CITY = 'city',
        REGION = 'region',
        LEGACY_COUNTRY = 'legacy_country',
        LEGACY_VOIDESHIP = 'legacy_voideship',
        LEGACY_CITY = 'legacy_city',
        LEGACY_REGION = 'legacy_region',
    }
}
